import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a glass double door in a matte-black frame: two glass leaves
// (each about 0.45 m wide, door height 2.05) with thin vertical pull
// handles, glass above the transom up to 2.4 and a black fascia band to the
// 2.6 m wall top. Same tile-long, 0.12 m thick wall convention as
// wall-plain, so it chains with storefront-window into a shop front.
const BLACK = "#2e2e30";
const BLACK_LIGHT = "#3c3c3f";
const GLASS = "#9fc4d4";
const STEEL = "#aab2b8";

export const storefrontDoor = defineModel({
  id: "storefront-door",
  batchId: "modern",
  name: "Storefront door",
  tags: ["modern", "outdoor", "structure", "wall", "door", "shop", "storefront", "entrance"],
  summary: "A glass double door in a matte-black frame with header glass to 2.4 m.",
  description:
    "A one-tile shop entrance of the Modern Living kit: two glass door " +
    "leaves (0.9 m opening, 2.05 m high) in a matte-black frame with thin " +
    "vertical pull handles, header glass above the transom to 2.4 m and a " +
    "black fascia band to the 2.6 m wall top. Pairs with storefront-window.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // matte-black jambs at both edges
      { geometry: new THREE.BoxGeometry(0.05, 2.4, 0.12), color: BLACK, position: [-0.475, 1.2, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 2.4, 0.12), color: BLACK, position: [0.475, 1.2, 0] },
      // transom bar over the door leaves (at 2.05)
      { geometry: new THREE.BoxGeometry(0.9, 0.08, 0.12), color: BLACK, position: [0, 2.09, 0] },
      // header glass above the transom (2.13 -> 2.4)
      { geometry: new THREE.BoxGeometry(0.9, 0.27, 0.08), color: GLASS, position: [0, 2.265, 0] },
      // head strip at 2.4 and fascia band to the wall top
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 0.12), color: BLACK, position: [0, 2.37, 0] },
      { geometry: new THREE.BoxGeometry(1.0, 0.2, 0.12), color: BLACK_LIGHT, position: [0, 2.5, 0] },
      // two glass door leaves, a thin dark seam between them
      { geometry: new THREE.BoxGeometry(0.43, 2.0, 0.08), color: GLASS, position: [-0.225, 1.02, 0] },
      { geometry: new THREE.BoxGeometry(0.43, 2.0, 0.08), color: GLASS, position: [0.225, 1.02, 0] },
      // bottom door rails
      { geometry: new THREE.BoxGeometry(0.9, 0.12, 0.1), color: BLACK, position: [0, 0.06, 0] },
      // thin vertical pull handles near the centre seam, on the +Z face
      { geometry: new THREE.BoxGeometry(0.03, 0.6, 0.03), color: STEEL, position: [-0.09, 1.1, 0.08] },
      { geometry: new THREE.BoxGeometry(0.03, 0.6, 0.03), color: STEEL, position: [0.09, 1.1, 0.08] },
    ];
  },
  animations: [],
});
